import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Third Party
import { User as Auth0User } from "@auth0/auth0-react";
import { Link } from "react-router-dom";

// Internal
import { PostType } from "../../../data/types";
import en from "../../../data/en.json";
import FeedItemActions from "./FeedItemActions";

interface PostProps {
  user?: Auth0User;
  post: PostType;
  handleReactPost: (postId: string) => void;
  handleFlagPost: (postId: string) => void;
  handleCommentPost: (postId: string, commentText: string) => void;
  handleAddToCollectionClick: (
    event: React.MouseEvent<HTMLElement>,
    post: PostType
  ) => void;
}

function Post(props: PostProps) {
  return (
    <Grid container direction="row" sx={{ p: 2 }}>
      <Grid item alignSelf="self-start" xs={2} sx={{ pl: 2 }}>
        <Avatar src={props.post.user.profile?.photo?.url} />
      </Grid>
      <Grid item xs={10}>
        <Box display="flex" flexDirection={"row"}>
          <Link
            key={props.post.user.handle}
            to={`/users/${props.post.user.handle}`}
            target="_blank"
            style={{ textDecoration: "none", color: "black" }}
          >
            <Typography variant="body2" sx={{ fontWeight: "bold", pr: 1 }}>
              {props.post.user.profile?.nickname ||
                en.community.unknownUsername}
            </Typography>
          </Link>
          <Typography variant="body1">{props.post.createdAt}</Typography>
        </Box>
        <Box sx={{ maxHeight: 250, overflow: "hidden", overflowY: "scroll" }}>
          <Typography variant="body2">{props.post.text}</Typography>
        </Box>
        {props.post.imageUrl && (
          <img
            alt="postImage"
            src={props.post.imageUrl}
            width={"100%"}
            height={"auto"}
          />
        )}
        <FeedItemActions
          user={props.user}
          reactions={props.post.reactions}
          comments={props.post.comments}
          onReact={() => props.handleReactPost(props.post.id)}
          onComment={(commentText) =>
            props.handleCommentPost(props.post.id, commentText)
          }
          onFlag={() => props.handleFlagPost(props.post.id)}
          onAddToCollection={(e) =>
            props.handleAddToCollectionClick(e, props.post)
          }
        />
      </Grid>
    </Grid>
  );
}

export default Post;
